module.exports = __webpack_public_path__ + "img/siren__2_@2x.2c3563dd.png";